import React, { FC, useEffect, useRef, useState } from 'react';
import './infinite-scroll.sass';
import Loader from '../../../../shared/components/loader/loader';
import { IGetPostsReturnValue } from '../../../../shared/services/api.service';

interface IInfiniteScrollProps {
  fetchNextPage: () => Promise<{ payload: IGetPostsReturnValue }>;
  onNewContent?: () => void;
  isPostFetched?: boolean;
}

const InfiniteScroll: FC<IInfiniteScrollProps> = ({ fetchNextPage, onNewContent, isPostFetched = false }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFetched, setIsFetched] = useState<boolean>(isPostFetched);
  const containerRef = useRef<HTMLDivElement | null>(null);

  const handleScroll = () => {
    if (
      document.documentElement.clientHeight + document.documentElement.scrollTop >
      Math.round(document.documentElement.scrollHeight * 0.75)
    ) {
      setIsLoading(true);
    }
  };

  useEffect(() => {
    if (containerRef && containerRef.current) {
      const observer = new IntersectionObserver(handleScroll, {
        root: null,
        rootMargin: '0px',
      });
      observer.observe(containerRef.current);
    }
  }, [containerRef]);

  useEffect(() => {
    if (isLoading) {
      fetchNextPage().then(data => {
        if (data && typeof data.payload.links.next === 'undefined') {
          setIsFetched(true);
        } else {
          onNewContent && onNewContent();
        }
        setIsLoading(false);
      });
    }
  }, [isLoading]);

  useEffect(() => {
    isFetched && window.removeEventListener('scroll', handleScroll);
  }, [isFetched]);

  return (
    <div
      ref={containerRef}
      data-testid="infinite-scroll"
      className={`infinite-scroll ${isLoading && 'infinite-scroll--active'}`}
    >
      {isLoading && <Loader />}
    </div>
  );
};

export default InfiniteScroll;
